import { forwardRef } from "react";
import type { ChangeEventHandler, FocusEvent, MouseEventHandler } from "react";
import ReactDatePicker from "react-datepicker";
import InputMask from "@colonnade-x/react-input-mask";

type DatePickerProps = {
  value: Date | null;
  onChange: (date: Date | null) => void;
  id?: string;
  name?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
};

type MaskedInputProps = {
  value?: string;
  onClick?: MouseEventHandler<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  id?: string;
  name?: string;
  disabled?: boolean;
};

const DATE_FORMAT = "MM/dd/yyyy";

const MaskedDateInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  (
    { value, onClick, onChange, onBlur, disabled, id, name, placeholder },
    ref,
  ) => {
    return (
      <InputMask
        mask="99/99/9999"
        maskPlaceholder="_"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        id={id}
        name={name}
        placeholder={placeholder}
      >
        <input
          className="form-control"
          style={{ minHeight: 30 }}
          name={name}
          id={id}
          onClick={onClick}
          ref={ref}
        />
      </InputMask>
    );
  },
);
MaskedDateInput.displayName = "MaskedDateInput";

const DatePickerComponent = forwardRef<ReactDatePicker, DatePickerProps>(
  (
    {
      value,
      onChange,
      id,
      name,
      className,
      placeholder,
      disabled,
      minDate,
      maxDate,
    },
    ref,
  ) => {
    return (
      <div className={className}>
        <div className="d-flex gap-2 align-items-center">
          <div className="flex-grow-1">
            <ReactDatePicker
              ref={ref}
              selected={value}
              className="form-control"
              wrapperClassName="w-100"
              onChange={onChange}
              dateFormat={DATE_FORMAT}
              showMonthDropdown
              shouldCloseOnSelect
              showYearDropdown
              todayButton="Today"
              dropdownMode="select"
              minDate={minDate}
              maxDate={maxDate}
              placeholderText={placeholder}
              popperPlacement="bottom-end"
              customInput={
                <MaskedDateInput id={id} name={name} disabled={disabled} />
              }
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    );
  },
);
DatePickerComponent.displayName = "DatePicker";

export default DatePickerComponent;
